import { ClickPosition } from '../Button.types';

export const radialEffect = {
  default: (p: ClickPosition): string => `
    &:after {
      background-position: 50%;
      background-repeat: no-repeat;
      border-radius: 50%;
      content: '';
      display: block;
      height: ${p.diameter}px;
      left: ${p.left};
      opacity: 0;
      pointer-events: none;
      position: absolute;
      top: ${p.top};
      transform: scale(4);
      transition: transform 0.6s, opacity 0.6s ease-in;
      width: ${p.diameter}px;
    }

    &:active:after {
      opacity: 0.4;
      transform: scale(0, 0);
      transition: 0s;
    }
  `,
  active: (color: string): string => `
    &:after {
      background: radial-gradient(
        circle at 50%,
        ${color} 100%,
        transparent,
        transparent 100%
      );
    }
  `,
};
